/**
 * 가망고객 서비스
 * - 부동산이 직접 등록하는 가망고객 DB
 */
import { db } from '../firebase/config';
import { collection, addDoc, getDocs, updateDoc, deleteDoc, doc, query, where, serverTimestamp } from 'firebase/firestore';

export const createProspect = async (realtorId, data) => {
  const ref = await addDoc(collection(db, 'realtor_prospects'), {
    realtor_id: realtorId,
    name: data.name || '',
    phone: (data.phone || '').replace(/\D/g, ''),
    memo: data.memo || '',
    status: 'pending',
    created_at: serverTimestamp(),
    updated_at: serverTimestamp(),
  });
  return ref.id;
};

export const getProspectsByRealtor = async (realtorId) => {
  const q = query(
    collection(db, 'realtor_prospects'),
    where('realtor_id', '==', realtorId)
  );
  const snap = await getDocs(q);
  const rows = snap.docs.map((d) => {
    const data = d.data();
    const tsMs = data.created_at?.toDate?.()?.getTime?.() || 0;
    return {
      id: d.id,
      ...data,
      _tsMs: tsMs,
      created_at: data.created_at?.toDate?.()?.toISOString?.() || null,
    };
  });
  rows.sort((a, b) => (b._tsMs || 0) - (a._tsMs || 0));
  return rows.map(({ _tsMs, ...r }) => r);
};

export const markProspectMessaged = async (id, channel = 'sms') => {
  const field = channel === 'kakao' ? 'last_kakao_at' : 'last_sms_at';
  await updateDoc(doc(db, 'realtor_prospects', id), {
    [field]: serverTimestamp(),
    last_sent_at: serverTimestamp(),
    updated_at: serverTimestamp(),
  });
};

export const updateProspect = async (id, data) => {
  await updateDoc(doc(db, 'realtor_prospects', id), {
    ...data,
    updated_at: serverTimestamp(),
  });
};

export const deleteProspect = async (id) => {
  await deleteDoc(doc(db, 'realtor_prospects', id));
};
